<template lang="pug">
.hello
  h1
    i.fas.fa-cogs.fa-5x
  h1 Ciao Mondo Il Mio Culo
  md-button.md-raised.md-primary Good Morning Midnight
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
